export default __webpack_public_path__ + "static/6-ef31385ed4fd57b8134146f1e9750497.jpg";